
import {map, catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { CognitoUtil } from './cognito.service';
import { RenewalEmploymentInfo } from '../app/models/renewal-employment-info';

@Injectable()
export class RenewalPrimaryEmployerService {
public static _API_ENDPOINT = environment.apiEndPoint;

  constructor(private http: HttpClient, private router: Router, private cognitoUtil: CognitoUtil) { }

  createOptions() {
    this.cognitoUtil.refresh();
    return {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('AWSCreds'),
            'Identity': localStorage.getItem('CognitoId'),
            'Sub': localStorage.getItem('CognitoSub')
        })
    };
}

getEmploymentInformation(model: RenewalEmploymentInfo) {
    return this.http.post(RenewalPrimaryEmployerService._API_ENDPOINT + 'RenewalCog/GetCurrentEmployer', model, this.createOptions())
    .pipe(
        catchError(this.handleError),
        map((response) => <RenewalEmploymentInfo>(response))
    );
}

updateEmploymentInformation(model: RenewalEmploymentInfo) {
    return this.http.post(RenewalPrimaryEmployerService._API_ENDPOINT + 'RenewalCog/UpdateEmploymentInfo', model, this.createOptions())
    .pipe(
        catchError(this.handleError),
        map((response) => <RenewalEmploymentInfo>(response))
    );
}

handleError(error: HttpErrorResponse) {
    let errMsg: string;
    if (error.status === 403) {
        this.router.navigate(['/logout']);
    }
    if (error.error  instanceof ErrorEvent) {
        const body = error.error;
        if (body.message) {
            errMsg = error.error.message;
        } else {
            const err = body;
            errMsg = `${error.statusText || ''} ${err}`;
        }
    } else {
        errMsg = error.message ? error.message : error.toString();
        if (errMsg.length === 0) {
            errMsg = 'There was an unknown error.  Please try again later';
        }
    }

    localStorage.setItem('RenewalErrorMessage', errMsg);
    this.router.navigate(['renewalcog/renewal-error']);
    return errMsg;
    }
  
}
